<template>
   <div class="row">
        <a href="/instagram/matteortiliart">
        <div class="col xl6 l6 m6 s12 cell"><div class="cellIG2"><div class="over waves-effect">        
        </div></div></div></a>

        <a href="/instagram/matteortili">
        <div class="col xl6 l6 m6 s12 cell"><div class="cellIG1"><div class="over waves-effect">
        </div></div></div></a>

    </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'MOAIG',
  metaInfo() {
    return {
      title: 'MOA - IG',
      meta: [
        {name: 'title', content:'Matteo Ortili Art - Instagram'},
        {name: 'description', content: 'Matteo Ortili\'s Instagram profiles'},
        {property: 'og:title', content: "Matteo Ortili Art - Instagram"},
        {property: 'og:site_name', content: 'MatteOrtiliArt (MOA)'},
        {property: 'og:type', content: 'website'},
        {property: 'og:url', content: 'https://www.matteortili.com/#/instagram'},
        {property: 'og:description', content: 'Matteo Ortili\'s Instagram profiles'},
        {property: 'og:image:secure_url', itemprop: 'image', content: 'https://www.matteortili.com/imgs/link_img.jpg'},
      ]
    }
  }
}
</script>

<style scoped>
    @import url('../assets/styles/portfolio.css');
</style>
